import { Options, Vue, Prop, Inject } from 'vue-property-decorator';
import { TopicStructuredMsg, GetTopicInfoItem } from '_c/typings/proto';
import KkButton from '@/component/kk-button/index.vue';
import KkIcon from '@/component/kk-icon/index.vue';
import { IMsg } from '_c/typings/model/im';
import EventBus from '_c/util/event-bus';
import { ChatPageEvents, ChatPageEventType } from '_c/typings/event/global';
import { report } from '_c/business/api/report';

@Options({
  name: 'TopicMessageView',
  components: {
    KkButton,
    KkIcon,
  },
})
export default class TopicMessageView extends Vue {
  @Prop({ required: true }) readonly topicData: TopicStructuredMsg;

  @Inject({ from: 'cid' }) readonly cid!: string;
  @Inject({ from: 'messageData' }) readonly messageData!: IMsg;
  @Inject({ from: 'chatPageEventBus' }) readonly chatPageEventBus!: EventBus<ChatPageEvents>;

  get topicInfo(): GetTopicInfoItem | undefined {
    return this.$store.state.chat.topicInfoMap[this.topicData.topicId];
  }

  get joinCountText(): string {
    const count = parseInt(this.topicInfo?.topicInfo.joinCnt || '', 10);
    if (count) {
      return `${count}个`;
    }
    return '暂无';
  }

  get canShowJoinButton(): boolean {
    return !!(this.topicInfo?.needShowJoinButton && this.topicInfo?.channelId === this.cid);
  }

  handlerJoinClick() {
    this.chatPageEventBus.emit(ChatPageEventType.editPanelAddTopic, {
      ...this.topicData,
      from: 1,
    });
    report({
      reportParamsList: [{
        operId: '1925007910204',
        ext1: this.topicData.topicId,
      }],
    });
  }

  handlerCountClick() {
    const channelId = this.topicInfo?.channelId;
    if (channelId) {
      this.chatPageEventBus.emit(ChatPageEventType.openTopicDetail, {
        channelId,
        topicId: this.topicData.topicId,
        from: 1,
      });
      report({
        reportParamsList: [{
          operId: '1925007910204',
          ext1: this.topicData.topicId,
        }],
      });
    }
  }
}
